export const LRCHeader = [
  { name: 'Valid Up To', subText: '', column: 1, hasHelpIcon: true },
  { name: 'Choose Extension Period', subText: '', column: 2, hasHelpIcon: true },
  { name: 'New Validity', subText: 'after extension', column: 1, hasHelpIcon: true },
  { name: 'Agreement', subText: 'download', column: 1, hasHelpIcon: false }
];

export const LRCSearchHeader = [
  { key: '' },
  { key: '3-YEAR-EXTN', label: '3 year (2-5)', isCheckbox: true },
  { key: '8-YEAR-EXTN', label: '8 years (2-10)', isCheckbox: true },
  { key: '' },
  { key: '' }
];

export const menuList = {
  system_id: 'System ID',
  name: 'Name',
  group_id: 'Groups',
  address: 'Street Address',
  city: 'City',
  state: 'State/Province',
  zip: 'Zip/Postal Code',
  installer_name: 'Installer',
  maintainer_name: 'PV System Maintainer',
  owner: 'Owner',
  ref_id: 'Installer Reference',
  pcu_channel_count: 'Microinverters',
  acb_count: 'AC Batteries',
  nsr_count: 'IQ Relays',
  data_source: 'Data Source',
  prod_eim_cfg: 'Production Meter',
  cons_eim_cfg: 'Consumption Meter',
  connection_type: 'Connection',
  status: 'Status',
  issue_count: 'Issues',
  install_date: 'Installed On',
  tpm_profile: 'Grid Profile',
  last_report: 'Last Report',
  operational: 'Operational',
  this_month_est_pct: 'This Months',
  interconnect_date: 'Interconnection Date',
  site_company_ref: `My Company's Reference`
};

export const LPPOverview = 'https://enphase.com/en-us/lpp-overview';
export const termsConditionsLink = 'https://enphase.com/en-us/legal/lpp-terms';
export const feinLink = 'https://www.irs.gov/businesses/small-businesses-self-employed/employer-id-numbers';

export const validUpto =
  'Time until which Labor reimbursement can be claimed for eligible RMAs for the respective site';
export const newValidity =
  'Time until which Labor reimbursement can be claimed for eligible RMAs for the respective site after the extension has been purchased';
